import "../../../styles/UserAuthPage.css";

function LeftPanel() {
  return (
    <div className="adminAuth__visual">
      <div className="adminAuth__overlay" />

      <div className="adminAuth__content">
        <h1 className="adminAuth__heading">C4SEAS Admin Dashboard</h1>

        <p className="adminAuth__text">
          Manage farmer registrations, monitor platform usage, and upload soil survey datasets
          across Kaduna and Kano states.
        </p>

        <div className="adminAuth__stats">
          <div className="adminAuth__stat">
            <strong>24/7</strong>
            <span>Monitoring</span>
          </div>

          <div className="adminAuth__stat">
            <strong>5000+</strong>
            <span>Soil Samples</span>
          </div>

          <div className="adminAuth__stat">
            <strong>Real-Time</strong>
            <span>Analytics</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeftPanel;
